import { useCallback } from 'react';

import { TargetModel, TargetStatus } from '../../../../modules/Apps';
import { useUpdateTarget } from '../../../../modules/Apps/Targets';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface EnableTargetDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  target: TargetModel;
}

export function EnableTargetDialog({ isOpen, handleClose, target }: EnableTargetDialogProps) {
  const { mutateAsync, isPending } = useUpdateTarget();
  const toaster = useToastNotification();

  const enableTarget = useCallback(async () => {
    try {
      await mutateAsync({ ...target, status: TargetStatus.Enabled });
      toaster.showSuccess('Target was successfully enabled!');
      handleClose();
    } catch (error) {
      toaster.showError('There was an error enabling the target. Please, try again later.');
    }
  }, [mutateAsync, target, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Enable"
      heading="Enable Target"
      text={`Are you sure you want to enable ${target.name} Target?`}
      handleConfirm={enableTarget}
      handleDismiss={handleClose}
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
